import React from 'react';
import './Intro.scss';
import introLogo from '../../assets/intro-logo.png';

function IntroCopy({ showHamburger, introText }) {
  return (
    <section className="introCopy">
      <a
        href="https://www.nar.realtor/"
        target="_blank"
        rel="noreferrer"
        className="nar introCopy__logo"
      >
        <img
          src={introLogo}
          className="intro__popup__logo"
          alt="Logo of National Association Of Realtors"
        />
      </a>
      <p className="intro__popup__title">THE STATE OF HOUSING IN AMERICA</p>
      <p
        className={
          showHamburger ? 'intro__popup__intro introCopy__hamburger' : 'intro__popup__intro'
        }
        ref={introText}
      >
        Not all real estate agents are REALTORS
        <span className="r">®</span>. Only agents who belong to the National Association of REALTORS
        <span className="r">®</span> (NAR) and adhere to its code of ethics can call themselves a
        REALTOR
        <span className="r">®</span> and use their trademark. REALTORS
        <span className="r">®</span> gain expertise through ongoing research, education, resources
        and thought leadership from NAR.
      </p>
    </section>
  );
}

export default IntroCopy;
